// HM-307: placeholder generico per i moduli non ancora implementati.
// Le 8 voci sidebar oltre Dashboard puntano qui finche' non arriva il
// cluster dedicato (15..27).

interface Props {
  title: string;
  cluster: number;
  description: string;
}

export function ModulePlaceholder({ title, cluster, description }: Props) {
  return (
    <div className="p-8">
      <div className="max-w-2xl mx-auto bg-bg-card rounded-xl shadow-hm-md p-10 mt-12 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-soft text-accent-primary-text text-xs font-semibold mb-4">
          Cluster {cluster}
        </div>
        <h1 className="text-3xl font-bold text-text-primary mb-3">{title}</h1>
        <p className="text-text-secondary">{description}</p>
        <p className="text-xs text-text-muted mt-6 font-mono">
          /dev/* per le pagine demo design-system di HM-301..305.
        </p>
      </div>
    </div>
  );
}
